/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

const EXPAND_MENU = 'EXPAND_MENU'
const initialState = {
    data: {},
    isMenuExpanded: false
}

export const actionCreators = {
    UpdateMenuExpanded: (isMenuExpanded: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: EXPAND_MENU, isMenuExpanded });
    }
};

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case EXPAND_MENU:
            return {
                ...state,
                isMenuExpanded: action.isMenuExpanded
            };
    }
    return state;
}